
import { useSelector } from "react-redux";
import { currentSelectedLanguage } from "../../../../StateManagement/actions";
import APIRequest from "../../../../Services/commonAPIConsumer";
import { useNavigate } from "react-router-dom";


const tabMap = {
    'Personal': 'personalTab',
    'Company': 'companyTab',
    'Admin': 'AdminTab'
};

export function useValidateSettings() {
    const selectedLanguage = useSelector(currentSelectedLanguage);
    const settings = useSelector((state) => state.settings);
    const searchedUser = useSelector((state) => state.settings.searchedUser);
    const searchedCompany = useSelector((state) => state.settings.searchedCompany);
    const isRestoredToDefaults = useSelector((state) => state.settings.restoreDefaults);
    const tabKey =
        tabMap[settings.settingFor === "User" ? "Personal" : settings.settingFor];
    const idLeakersType =
        settings[tabKey]?.selectedTab === "ContentSecurity"
            ? settings[tabKey]?.settingsData?.[0]?.commonContentSecuritySetting
                ?.find(s => s.type === "IDLeakersType")?.keyValue
            : null;
    const history = useNavigate();
    const userRole = localStorage.getItem("UserRole");
    function validateReadsPerReader(groupSettings) {
        const getVal = (type) => {
            const found = groupSettings.find(
                (s) => s.type?.toLowerCase() === type.toLowerCase()
            );
            return found ? parseInt(found.keyValue, 10) || 0 : 0;
        };
        const maxReadsPerReader = getVal("MaxReadsPerReader");
        const maxViewsPerDocument = getVal("MaxViewsPerDocument");
        if (
            maxReadsPerReader > 0 &&
            maxViewsPerDocument > 0 &&
            maxReadsPerReader > maxViewsPerDocument
        ) {
            return {
                message: selectedLanguage.LstLanguageCodes.UI_Readsperreadercannotexceedviewsperdocument,
                type: "warning",
            };
        }
        return true;
    }
    function validatePrintsPerReader(groupSettings) {
        const getVal = (type) => {
            const found = groupSettings.find(
                (s) => s.type?.toLowerCase() === type.toLowerCase()
            );
            return found ? parseInt(found.keyValue, 10) || 0 : 0;
        };
        const maxPrintsPerReader = getVal("MaxPrintsPerReader");
        const maxPrintsPerDocument = getVal("MaxPrintsPerDocument");
        if (
            maxPrintsPerReader > 0 &&
            maxPrintsPerDocument > 0 &&
            maxPrintsPerReader > maxPrintsPerDocument
        ) {
            return {
                message: selectedLanguage.LstLanguageCodes.UI_Printsperreadercannotexceedprintspersdocument,
                type: "warning",
            };
        }
        return true;
    }
    function showConfirmationPopup() {

        try {
            const tabKey = tabMap[settings.settingFor === "User" ? "Personal" : settings.settingFor];
            if (settings[tabKey]?.selectedTab === "Profile") return false;
            let commonSettings = [];
            let l1Settings = [];
            let l2Settings = [];
            let l3Settings = [];
            let cipherTextSettings = [];
            let floatingTextSettings = [];
            if (settings[tabKey]?.selectedTab === "DirectSendDefaults") {
                commonSettings = settings[tabKey]?.settingsData.find(s => s.settingFor === settings.defaultSetting).commonSettings;
                l1Settings = settings[tabKey]?.settingsData.find(s => s.settingFor === settings.defaultSetting).l1;
                l2Settings = settings[tabKey]?.settingsData.find(s => s.settingFor === settings.defaultSetting).l2;
                l3Settings = settings[tabKey]?.settingsData.find(s => s.settingFor === settings.defaultSetting).l3;
                if (isRestoredToDefaults?.l1 || isRestoredToDefaults?.l2 || isRestoredToDefaults?.l3) {
                    return true;
                }
            }
            else if (settings[tabKey]?.selectedTab === "ContentSecurity") {
                commonSettings = settings[tabKey]?.settingsData[0]?.commonContentSecuritySetting;
                cipherTextSettings = settings[tabKey]?.settingsData[0]?.cipherText;
                floatingTextSettings = settings[tabKey]?.settingsData[0]?.floatingText;
                if (isRestoredToDefaults.cipher || isRestoredToDefaults.floating) {
                    return true;
                }
                const eDisclosureSetting = commonSettings?.find(s => s.type === "EDisclosure");
                if (eDisclosureSetting) {
                    if (eDisclosureSetting.isDataChanged) return true;
                    const levelChanged = eDisclosureSetting.keyCollection?.some(
                        (level) =>
                            level.prevLevelFlag !== undefined &&
                            level.levelFlag !== level.prevLevelFlag
                    );
                    if (levelChanged) return true;
                }
            }
            else {
                commonSettings = settings[tabKey]?.settingsData;
            }
            const settingsChanged = commonSettings.find(
                (setting) => setting?.isDataChanged
            );
            const l1SettingsChanged = l1Settings.find(
                (setting) => setting?.isDataChanged
            );
            const l2SettingsChanged = l2Settings.find(
                (setting) => setting?.isDataChanged
            );
            const l3SettingsChanged = l3Settings.find(
                (setting) => setting?.isDataChanged
            );
            const cipherTextSettingsChanged = cipherTextSettings.find(
                (setting) => setting?.isDataChanged
            );
            const floatingTextSettingsChanged = floatingTextSettings.find(
                (setting) => setting?.isDataChanged
            );

            if (
                settingsChanged || l1SettingsChanged || l2SettingsChanged || l3SettingsChanged || cipherTextSettingsChanged || floatingTextSettingsChanged
            ) {
                return true;
            }
        }
        catch (error) {
            console.log(error);
        }
        return false;
    }




    function validateSettings() {
        try {
            const tabKey = tabMap[settings.settingFor === "User" ? "Personal" : settings.settingFor];
            let commonSettings = [];
            let l1Settings = [];
            let l2Settings = [];
            let l3Settings = [];
            let cipherTextSettings = [];
            let floatingTextSettings = [];
            if (settings[tabKey]?.selectedTab === "Profile") {
                return true;
            }
            if (settings[tabKey]?.selectedTab === "DirectSendDefaults") {
                commonSettings = settings[tabKey]?.settingsData.find(s => s.settingFor === settings.defaultSetting).commonSettings;
                l1Settings = settings[tabKey]?.settingsData.find(s => s.settingFor === settings.defaultSetting).l1;
                l2Settings = settings[tabKey]?.settingsData.find(s => s.settingFor === settings.defaultSetting).l2;
                l3Settings = settings[tabKey]?.settingsData.find(s => s.settingFor === settings.defaultSetting).l3;
            }
            else if (settings[tabKey]?.selectedTab === "ContentSecurity") {
                commonSettings = settings[tabKey]?.settingsData[0]?.commonContentSecuritySetting;
                cipherTextSettings = settings[tabKey]?.settingsData[0]?.cipherText;
                floatingTextSettings = settings[tabKey]?.settingsData[0]?.floatingText;
            }
            else {
                commonSettings = settings[tabKey]?.settingsData;
            }

            const settingsChanged = commonSettings.filter(
                (setting) => setting?.isDataChanged
            );
            const l1SettingsChanged = l1Settings.filter(
                (setting) => setting?.isDataChanged
            );
            const l2SettingsChanged = l2Settings.filter(
                (setting) => setting?.isDataChanged
            );
            const l3SettingsChanged = l3Settings.filter(
                (setting) => setting?.isDataChanged
            );
            const cipherTextSettingsChanged = cipherTextSettings.filter(
                (setting) => setting?.isDataChanged
            );
            const floatingTextSettingsChanged = floatingTextSettings.filter(
                (setting) => setting?.isDataChanged
            );
            const settingGroupsToValidate =
                settings[tabKey]?.selectedTab === "DirectSendDefaults"
                    ? [commonSettings, l1Settings, l2Settings, l3Settings]
                    : [commonSettings];

            for (const group of settingGroupsToValidate) {
                if (!group || group.length === 0) continue;
                const readsValidation = validateReadsPerReader(group);
                if (readsValidation !== true) return readsValidation;
                const printsValidation = validatePrintsPerReader(group);
                if (printsValidation !== true) return printsValidation;
            }
            if (settingsChanged && settingsChanged.length > 0) {
                const sideNoteValidation = validateSideNote(settingsChanged);
                if (sideNoteValidation !== true) return sideNoteValidation;
                const restrictToDomainsValidation = validateRestrictToDomains(settingsChanged, /^(?!@)[A-Za-z0-9-]+([\-.])+[A-Za-z]{3}$/);
                if (restrictToDomainsValidation !== true) return restrictToDomainsValidation;
                const termsOfServiceValidation = validateTermsOfService(settingsChanged);
                if (termsOfServiceValidation !== true) return termsOfServiceValidation;
            }
            const eDisclosureValidation = validateEDisclosureSecurityLevels(settingsChanged, commonSettings);
            if (eDisclosureValidation !== true) return eDisclosureValidation;

            if (cipherTextSettingsChanged && cipherTextSettingsChanged.length >= 0) {
                const cipherShapeValidation = validateCipherShape(cipherTextSettings);
                if (cipherShapeValidation !== true) return cipherShapeValidation;
            }

            if (l1SettingsChanged && l1SettingsChanged.length > 0) {
                const sideNoteValidation = validateSideNote(l1SettingsChanged);
                if (sideNoteValidation !== true) return sideNoteValidation;
                const restrictToDomainsValidation = validateRestrictToDomains(l1SettingsChanged, /^(?!@)[A-Za-z0-9-]+([\-.])+[A-Za-z]{3}$/);
                if (restrictToDomainsValidation !== true) return restrictToDomainsValidation;
            }

            if (l2SettingsChanged && l2SettingsChanged.length > 0) {
                const sideNoteValidation = validateSideNote(l2SettingsChanged);
                if (sideNoteValidation !== true) return sideNoteValidation;
                const restrictToDomainsValidation = validateRestrictToDomains(l2SettingsChanged, /^(?!@)[A-Za-z0-9-]+([.\-])+[A-Za-z]{3}$/);
                if (restrictToDomainsValidation !== true) return restrictToDomainsValidation;
            }

            if (l3SettingsChanged && l3SettingsChanged.length > 0) {
                const sideNoteValidation = validateSideNote(l3SettingsChanged);
                if (sideNoteValidation !== true) return sideNoteValidation;
                const restrictToDomainsValidation = validateRestrictToDomains(l3SettingsChanged, /^(?!@)[A-Za-z0-9-]+([.\-])+[A-Za-z]{3}$/);
                if (restrictToDomainsValidation !== true) return restrictToDomainsValidation;
            }
            return true;
        }
        catch (error) {
            console.log(error);
            return false;
        }
    }


    function validateSideNote(settingsToValidate) {
        const sideNote = settingsToValidate.find(setting => setting.type === "SideNote");
        if (sideNote && sideNote.keyValue.length > 512) {
            return { message: selectedLanguage.LstLanguageCodes.UI_SideNotemustbelessthanorequal, type: "warning" };
        }
        return true;
    }

    function validateCipherShape(settingsToValidate) {
        const cipherPattern = settingsToValidate.find(setting => setting.type === "CipherPattern");
        const cipherShape = settingsToValidate.find(setting => setting.type === "Shape");
        if (cipherShape && cipherShape.keyValue === "0" && cipherPattern && cipherPattern.keyValue === "2" && idLeakersType !== "Floating Text Only") {
            return { message: selectedLanguage.LstLanguageCodes.UI_SelectCipherShape, type: "warning" };
        }
        return true;
    }


    function validateRestrictToDomains(settingsToValidate, regexPattern) {
        const restrictSetting = settingsToValidate.find(setting => setting.type === "RestrictToDomains");
        if (restrictSetting && restrictSetting.keyValue) {
            const value = restrictSetting.keyValue;
            if (
                value !== "" &&
                value.split(",").length === 1 &&
                value.length > 190
            ) {
                return { message: selectedLanguage.LstLanguageCodes.UI_ThedomainmustbelessthanNum, type: "warning" };
            }
            let domainvalidation = false;
            if (value !== "" && value.split(",").length > 1) {
                value.split(",").forEach((element) => {
                    if (element.length > 190 && !domainvalidation) {
                        domainvalidation = true;
                    }
                });
            }
            if (domainvalidation) {
                return { message: selectedLanguage.LstLanguageCodes.UI_ThedomainmustbelessthanNum, type: "warning" };
            }
            const restrictToDomains = value !== "" ? value.split(",").map(d => d.trim()) : [];
            if (restrictToDomains.length > 10) {
                return { message: selectedLanguage.LstLanguageCodes.UI_Addupto10domainsseparatedbycomma, type: "warning" };
            }
            if (restrictToDomains.length >= 1) {
                const uniqueDomains = new Set();
                for (let domain of restrictToDomains) {
                    if (uniqueDomains.has(domain.toLowerCase())) {
                        return { message: selectedLanguage.LstLanguageCodes.UI_DuplicateDomain, type: "warning" };
                    }
                    uniqueDomains.add(domain.toLowerCase());
                    const regex = /^[A-Za-z0-9-]+(\.[A-Za-z]{2,})+$/;
                    if (!regex.test(domain)) {
                        return { message: selectedLanguage.LstLanguageCodes.UI_InvalidDomain, type: "warning" };
                    }
                }
            }
        }
        return true;
    }

    function validateTermsOfService(settingsToValidate) {
        const termsOfService = settingsToValidate.find(setting => setting.type === "TermsOfService");
        if (termsOfService && termsOfService.keyValue === "") {
            return { message: selectedLanguage.LstLanguageCodes.UI_TermsOfServiceCannotBeEmpty, type: "warning" };
        }
        if (termsOfService && termsOfService.keyValue) {
            const plainText = termsOfService.keyValue.replace(/<[^>]*>/g, "");
            if (plainText.length > 1024) {
                return { message: selectedLanguage.LstLanguageCodes.UI_TermsOfServiceCannotGreater, type: "warning" };
            }
        }
        return true;
    }
    function validateEDisclosureSecurityLevels(settingsToValidate, allSettings) {
        const eDisclosure = (allSettings || settingsToValidate).find(setting => setting.type === "EDisclosure");
        if (eDisclosure && eDisclosure.keyValue === "true") {
            const hasLevels = eDisclosure.keyCollection && eDisclosure.keyCollection.length > 0;
            const isAnyLevelSelected = hasLevels && eDisclosure.keyCollection.some((level) => level.levelFlag === true);
            if (!isAnyLevelSelected) {
                return { message: selectedLanguage.LstLanguageCodes.UI_AtleastOneLevelmustbeSelected, type: "warning" };
            }
        }
        return true;
    }

    async function VerifyAddOnEnabled(isFromStorage) {
        try {
            const baseUrl = `${process.env.REACT_APP_API}${process.env.REACT_APP_API_AddOnPlanEnabledOrNot}`;
            const companyName = userRole !== "RDocsSupportAdmin"
                ? localStorage.getItem("Companyname")
                : searchedCompany;
            const userEmail = settings.settingFor !== "User"
                ? searchedUser
                : localStorage.getItem("UserName");

            const params = new URLSearchParams({
                Lang: localStorage.getItem("language"),
                companyName: companyName,
                userEmail: userEmail,
                source: "UI",
                isFromStorage: isFromStorage
            });

            const response = await APIRequest.GET(
                "",
                `${baseUrl}?${params.toString()}`
            );
            if (response && response === "Server maintenance") {
                history("/maintenance");
                return;
            }

            if (response && response !== "Failed to fetch") {
                if (response.errorMessage == undefined || response.errorMessage == "") {
                    if (!response.addOnPlanExistsOrNot) {
                        const validationMessage = isFromStorage ? selectedLanguage.LstLanguageCodes.UI_NoStoragePlan : selectedLanguage.LstLanguageCodes.UI_NoPlanIsAssigned
                        return { message: validationMessage, type: "warning" };
                    }
                    return { message: response.addOnPlanExistsOrNot, type: "success" };
                } else {
                    return { message: response.errorMessage, type: "warning" };
                }
            } else {
                return { message: selectedLanguage.LstLanguageCodes.UI_FailedtoLoadSetting, type: "warning" };
            }
        } catch (error) {
            return { message: selectedLanguage.LstLanguageCodes.UI_FailedtoLoadSetting, type: "warning" };
        }
    }



    return { validateSettings, showConfirmationPopup, VerifyAddOnEnabled }
}


export default useValidateSettings;


